import React from 'react';
import Hero from '../../components/Hero';
import imageBig from '../../assets/images/projects-header-big.jpg';
import imageSmall from '../../assets/images/projects-header-small.jpg';
import { Box, ContentWrapper } from '../../components/Layout';
import { List } from '../../components/Lists';
import Link from 'gatsby-link';
import colors from '../../utils/colors.js';
import Config from '../../meta/config'
import SEO from '../../components/SEO'

export default ({ data }) => {
  const { edges: projects } = data.allMarkdownRemark;
  return (
    <div>
      <SEO 
      title={Config.siteTitle}
      description={Config.siteDescription}
      />
      <Hero
        imageBig={imageBig}
        imageSmall={imageSmall}
      >
        <Box color='white' p={[3, 3, 4]} align='left'>
          <h1>Projects</h1>
        </Box>
      </Hero>
      <Box color={colors.black} p={[3, 3, 4]} align='left'>
        <List>
          {projects.map(({node: project}, index) => {
            return (
              <li key={index}>
                <ContentWrapper>
                  <h1>
                    <Link to={project.fields.slug}>
                      {project.frontmatter.title}
                    </Link>
                  </h1>
                  <p>{project.frontmatter.description}</p>
                </ContentWrapper>
              </li>
            )
          })}
        </List>
      </Box>
    </div>
  )
}

export const pageQuery = graphql`
  query ProjectQuery {
    allMarkdownRemark (filter: { frontmatter: { category: { eq: "project" } }}){
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            title
            category
            description
            date
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/projects/index.js